import React, { useEffect, useState } from "react";
import { Button, FormSelect, Pagination, Spinner, Table } from "react-bootstrap";
import { ChevronLeft, Gear, PlusLg } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { fetchApi, range } from "../../../Funciones";

export const Home: React.FC = () => {
	let auth = useAuth();
	let nav = useNavigate();

	const [listado, setListado] = useState<any>([])
	const [pagina, setPagina] = useState(0)
	const [porPagina, setPorPagina] = useState(localStorage.getItem("porPagina") ? parseInt(localStorage.getItem("porPagina") + "") : 10)
	const [cargando, setCargando] = useState(false)
	const [total, setTotal] = useState(0)

	var filtradas = listado;
	var paginas = range(1, Math.ceil(total / porPagina) + 1)

	const getData = async () => {
		setCargando(true)
		var data = await fetchApi(auth.user.token, "page", {
			cmd: "listTemplates",
			p: pagina,
			pp: porPagina
		})
		setListado(data.listado)
		setTotal(data.total)
		setCargando(false)
	}

	useEffect(() => {
		
	}, [])

	useEffect(() => {
		if (auth.user) {
			getData()
		}
		// eslint-disable-next-line
	}, [auth.user, pagina, porPagina])

	return <>
		<Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>
		<h4>Plantillas</h4>

		<div className="py-2">
			<Button variant="outline-dark" className="d-inline-block" onClick={() => nav("edit")}>Nueva Plantilla <PlusLg /></Button>
			<FormSelect className="d-inline-block w-auto ms-4" title="Por Página" value={porPagina} onChange={(ev) => {
				setPagina(0)
				setPorPagina(parseInt(ev.target.value));
				localStorage.setItem("porPagina", ev.target.value)
			}}>
				<option value={10}>10</option>
				<option value={25}>25</option>
				<option value={50}>50</option>
				<option value={100}>100</option>
			</FormSelect>
			{total > porPagina && <div className="d-inline-block ms-4">
				<Pagination>
					<Pagination.First onClick={() => setPagina(0)} />
					{paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
					<Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
				</Pagination>
			</div>}
			{cargando && <Spinner animation="border" className="d-inline-block ms-4" />}
		</div>

		{listado && listado.length > 0 && <Table bordered hover striped size="sm" className="shadow">
			<thead>
				<tr>
					<th className="text-center">ID</th>
					<th className="text-center">Acciones</th>
					<th>Título</th>
					<th>Descripción</th>
					<th>Resumen</th>
				</tr>
			</thead>
			<tbody>
				{filtradas.map((item: any, i: any) => <tr key={item.id}>
					<td className="text-center" width={60}>{item.id}</td>
					<td className="text-center" width={120} style={{ verticalAlign: "middle" }}>
						<Button size="sm" variant="dark" onClick={() => nav("edit/" + item.id)}><Gear /> Editar</Button>
					</td>
					<td>{item.title}</td>
					<td>{item.description}</td>
					<td>{item.resumen}</td>
				</tr>)}
			</tbody>
		</Table>}
	</>
}